import React, { Component } from "react";
import "react-responsive-modal/styles.css";
// import { Modal } from "react-responsive-modal";
import { Image, Button, Row, Modal } from "react-bootstrap";
// import { PopupActionButton } from "../../buttonReusableComponent/ButtonReusableComponent";
import CallingButtonPopup from "../CallingButtonPopup";
import SendSmsButton from "../SendSmsButton";
import ViewButtonPopup from "../ViewButtonPopup";
import NotificationButton from "../NotificationButton";
import MapReusable from "./MapReusable";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import isEmpty from "../../../../store/validation/is-Empty";
import Media from "react-media";
import { NewCountDown } from "../tableNumberPopup/NewCountDown";
import TestMap from "../../../vendorDashboardComponents/UserTracking/TestMap";
import moment from "moment";
import SocketContext from "../../../../function/SocketContext";
import SendSmsNew from "../SendSmsNew";
import NotificationsNew from "../NotificationsNew";

import LocationIcon from "../../../../assets/images/ActionImages/maps-and-flagsred.png";
import LocationDisabled from "../../../../assets/images/ActionImages/maps-and-flags.png";
import CallingIconButtonActionFile from "../tableNumberPopup/CallingIconButtonAction/CallingIconButtonActionFile";
// import {GoogleApiWrapper} from 'google-maps-react';

export class LocationReusableScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      allLocationData: {},
      name: "",
      hasSetLocationProps: false,
      showMap: false,
      distance: {},
    };
  }

  async componentDidMount() {
    //this event will trigger only when there is change in any diner request
    this.props.socket.service("diner").on("update_location", async (data) => {
      if (
        data.diner_status !== "CANCELLED" ||
        data.diner_status !== "COMPLETED"
      ) {
        this.setState({ allLocationData: data });
      }
    });
    this.props.socket
      .service("ordering")
      .on("update_location", async (data) => {
        if (data.order_status !== 7 || data.order_status !== 8) {
          this.setState({ allLocationData: data });
        }
      });
    this.props.socket
      .service("user/event-handler")
      .on("patched", async (data) => {
        if (data.order_status !== 7 || data.order_status !== 8) {
          this.setState({ allLocationData: data });
        }
      });
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (!isEmpty(nextProps.dataSend) && !nextState.hasSetLocationProps) {
      return {
        allLocationData: !isEmpty(nextProps.dataSend) ? nextProps.dataSend : {},
        name: !isEmpty(nextProps?.dataSend?.user_details?.name)
          ? nextProps?.dataSend?.user_details?.name
          : "",
        hasSetLocationProps: true,
      };
    }
    if (!isEmpty(nextProps.distance.data)) {
      let distance =
        nextProps.distance.data?.rows[0].elements[0].distance?.text?.split(
          " "
        )[0] || "0";
      let eta =
        nextProps.distance.data.rows[0].elements[0].duration?.value || 0;
      return {
        distance: { distance, eta },
      };
    }
    return null;
  }

  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(prevProps.dataSend) !== JSON.stringify(this.props.dataSend)
    ) {
      this.setState({ allLocationData: this.props.dataSend });
    }
    if (
      JSON.stringify(prevProps.distance) !== JSON.stringify(this.props.distance)
    ) {
      let distance =
        this.props.distance.data?.rows[0].elements[0].distance?.text?.split(
          " "
        )[0] || "0";
      let eta =
        this.props.distance.data.rows[0].elements[0].duration?.value || 0;
      this.setState({
        distance: { distance, eta },
      });
    }
  }

  onOpenModal = (e) => {
    this.setState({ open: true });
  };

  onCloseModal = (e) => {
    this.setState({ open: false });
  };

  handleShowMap = () => {
    this.setState({
      showMap: !this.state.showMap,
    });
  };

  render() {
    const { open, allLocationData, showMap } = this.state;
    const { dataSend } = this.props;
    // console.log("dataSend, allLocationData", dataSend, allLocationData);
    return (
      <div>
        <div
          className={`text-blue f10-500 d-flex align-items-center justify-content-center`}
          onClick={this.props?.disabled ? this.onCloseModal : this.onOpenModal}
          style={{ cursor: `${this.props?.disabled ? "no-drop" : "pointer"}` }}
        >
          <Image
            src={this.props.disabled ? LocationDisabled : LocationIcon}
            fluid
            alt="Location"
            title="Location"
            className="location-image"
          />
          {this.props.display && (
            <span className="pl-2">
              Track User
              {/* <br /> Location{" "} */}
            </span>
          )}
        </div>

        {/* <Modal
          open={open}
          onClose={this.onCloseModal}
          center
          classNames={{
            overlay: "customOverlay-request-accept-cancelled",
            modal: "main-location-popup customModal-view-action closeRemove",
            closeButton: "customCloseButton",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
          }}
          animationDuration={1000}
        > */}
        <Modal
          show={open}
          onHide={this.onCloseModal}
          centered
          size="lg"
          style={{ zIndex: "1060" }}
        >
          <Modal.Header className="border-0 px-md-4" closeButton>
            <Modal.Title className="f24-700">User Location</Modal.Title>
          </Modal.Header>
          {/* <Modal.Body className="p-md-4"> */}
          <div>
            <Media query="(max-width: 991px)">
              <>
                {/* <div className="d-flex align-items-center py-3 px-4">
                  <span className="pr-3 cursor" onClick={this.onCloseModal}>
                    <Image
                      alt="Back"
                      width="20px"
                      src={require("../../../../assets/images/UserManagement/backIcon.svg")}
                    />
                  </span>
                  <div className="f12-400 c_black">User Location</div>
                </div> */}
                <div
                  className={`border-bottom border-top px-3  ${
                    allLocationData.service_type === "RESERVATION"
                      ? "enLeftYellowLine"
                      : "enLeftGReenLine"
                  }`}
                >
                  <div className="row justify-content-between ">
                    <div className="col-5 py-3">
                      <div className="d-flex align-items-center">
                        {allLocationData.isWalkIn === true &&
                        allLocationData.service_type === "SEATING" ? (
                          <Image
                            src={require("../../../../assets/images/ActionImages/image/walkin.svg")}
                            alt="Order Type"
                            title="Order Type"
                            className="order-type-Image mr-2"
                          />
                        ) : null ||
                          (allLocationData.isWalkIn === false &&
                            allLocationData.service_type === "SEATING") ? (
                          <Image
                            src={require("../../../../assets/images/ActionImages/image/waitlist.svg")}
                            alt="Order Type"
                            title="Order Type"
                            className="order-type-Image mr-2"
                          />
                        ) : null ||
                          allLocationData.service_type === "RESERVATION" ? (
                          <Image
                            src={require("../../../../assets/images/ActionImages/image/reservation.svg")}
                            alt="Order Type"
                            title="Order Type"
                            className="order-type-Image mr-2"
                          />
                        ) : null}
                        <div>
                          <div className="f12-500">{this.state.name}</div>
                          <div className="f10-500 opacity5">
                            #{allLocationData.diner_id}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-3 py-3 px-0 request-accept-cancelled-center section-two inline-section-two">
                      <div className="d-flex">
                        <div className="col-auto p-0">
                          <div className="f14-700">
                            {allLocationData?.order_type === 3
                              ? allLocationData?.totalDinePax
                              : "0"}
                          </div>
                          <div className="f10-700">PAX</div>
                        </div>
                        {allLocationData?.order_type === 3 ? (
                          <>
                            <div className="col-auto px-1">
                              {allLocationData?.adult_count === 0 ? null : (
                                <div className="d-flex align-items-center mb-2">
                                  <Image
                                    src={require("../../../../assets/images/ActionImages/employees.png")}
                                    fluid
                                    width="20px"
                                    alt="Adult"
                                    title="Adult"
                                    className="icon-image"
                                  />
                                  <span className="">
                                    {allLocationData.adult_count}
                                  </span>
                                </div>
                              )}
                              {allLocationData?.kids_count === 0 ? null : (
                                <div className="d-flex align-items-center">
                                  <Image
                                    src={require("../../../../assets/images/ActionImages/children.png")}
                                    fluid
                                    width="20px"
                                    alt="Children"
                                    title="Children"
                                    className="icon-image"
                                  />
                                  <span className="f9-400">
                                    {allLocationData.kids_count}
                                  </span>
                                </div>
                              )}
                            </div>
                            <div className="col-auto p-0">
                              {allLocationData?.handicap_chair === 0 ? null : (
                                <div className="d-flex align-items-center mb-2">
                                  <Image
                                    src={require("../../../../assets/images/ActionImages/highchair.png")}
                                    fluid
                                    width="10px"
                                    alt="Highchair"
                                    title="Highchair"
                                    className="icon-image-small"
                                  />
                                  <span className="f9-400">
                                    {allLocationData.handicap_chair}
                                  </span>
                                </div>
                              )}
                              {allLocationData?.high_chair === 0 ? null : (
                                <div className="d-flex align-items-center">
                                  <Image
                                    src={require("../../../../assets/images/ActionImages/wheelchair.png")}
                                    fluid
                                    width="10px"
                                    alt="Wheel Chair"
                                    title="Wheel Chair"
                                    className="icon-image-small"
                                  />
                                  <span className="f9-400">
                                    {allLocationData.high_chair}
                                  </span>
                                </div>
                              )}
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-4 py-3 p-0 text-break">
                      <div
                        className={
                          allLocationData.service_type === "reservation" ||
                          allLocationData.diner_status === "SEATED" ||
                          allLocationData.diner_status === "NOTSEATED" ||
                          allLocationData.diner_status === "PENDING" ||
                          allLocationData.diner_status === "REJECTED" ||
                          allLocationData.diner_status === "COMPLETED"
                            ? "card-header-right justify-content-center"
                            : "card-header-right"
                        }
                      >
                        {allLocationData.diner_status === "PENDING" ? (
                          <div>
                            <div>
                              <p className="f14-700 text-red">Pending</p>
                            </div>
                          </div>
                        ) : null ||
                          allLocationData.service_type === "RESERVATION" ? (
                          <div>
                            <p className="f12-500 text-dark">25Th Aug</p>
                            <div>
                              <p className="f14-700 text-red">09:04 PM</p>
                            </div>
                          </div>
                        ) : null ||
                          allLocationData.diner_status === "SEATED" ? (
                          <div>
                            <div>
                              <p className="f14-700 text-red">00:00</p>
                            </div>
                          </div>
                        ) : null ||
                          allLocationData.diner_status === "NOTSEATED" ? (
                          <div className="d-flex align-items-center justify-content-between">
                            <div>
                              <div>
                                <div className="f10-400 opacity5">ETA</div>
                                <p className="f14-700 text-red">
                                  <NewCountDown />
                                  {/* waitNew={diff} */}
                                </p>
                              </div>
                            </div>
                          </div>
                        ) : null ||
                          allLocationData.diner_status === "REJECTED" ? (
                          <div>
                            <p className="f14-700 text-red">Rejected</p>
                          </div>
                        ) : null ||
                          allLocationData.diner_status === "COMPLETED" ? (
                          <div>
                            <p className="f14-700 text-red">Completed</p>
                          </div>
                        ) : null ||
                          allLocationData.diner_status === "CANCELLED" ? (
                          <div className="w-100">
                            <p className="f14-700 text-red">Cancelled</p>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row px-3 justify-content-center mt-3 mb-4">
                  <div className="col-auto px-0">
                    {/* <CallingButtonPopup
                      buttonClass="bigButton"
                      sendData={dataSend}
                      displayButton={"OrderMain"}
                    /> */}
                    <CallingIconButtonActionFile
                      orderDetails={dataSend?.user_details}
                      actionType="orderFirstLastName"
                    />
                  </div>
                  <div className="col-auto px-0">
                    <SendSmsButton
                      buttonClass="bigButton"
                      sendData={dataSend}
                    />
                  </div>
                  <div className="col-auto px-0">
                    <NotificationButton
                      buttonClass="bigButton"
                      sendData={dataSend}
                    />
                  </div>
                </div>
                <div className="mapMobile">
                  <p className="f12-500 updatedLocation">
                    {`Updated Location : ${
                      this.state.distance.distance || 0
                    } KMS`}
                  </p>
                  {/* <MapReusable /> */}
                  {!isEmpty(allLocationData.track_location?.latitude) &&
                  !isEmpty(allLocationData.track_location?.longitude) ? (
                    <TestMap
                      restaurantLocation={
                        this.props?.type === "EVENT"
                          ? this.props?.dataSend?.location
                          : this.props.onboarding
                      }
                      userLocation={
                        allLocationData && allLocationData.track_location
                      }
                      travelMode={allLocationData?.travelMode}
                      socket={this.props.socket}
                      orderType={allLocationData?.order_type}
                    />
                  ) : (
                    <div> User Location Not Available </div>
                  )}
                </div>
              </>
            </Media>
            <Media query="(min-width: 992px)">
              <div className="p-3">
                {/* <div className="f20_700_HelveticaNeue pb-3">User Location</div> */}
                <div className="enGrayBorderBox">
                  <Row className="px-3 ">
                    <div
                      className={
                        this.props.actionBy === "merchantOrder"
                          ? "col-2"
                          : "col-md-5 py-2"
                      }
                    >
                      {this.props.actionBy === "merchantOrder" ? (
                        <>
                          <div className="f12-500 pb-2 pt-2">Order Type</div>
                          <img
                            src={
                              allLocationData &&
                              allLocationData.order_type === 0
                                ? require("../../../../assets/images/superadmin/ordericon/takeaway.svg")
                                : allLocationData &&
                                  allLocationData.order_type === 1
                                ? require("../../../../assets/images/superadmin/ordericon/curb side.svg")
                                : allLocationData &&
                                  allLocationData.order_type === 3
                                ? require("../../../../assets/images/superadmin/ordericon/dine in.svg")
                                : allLocationData &&
                                  allLocationData.order_type === 2
                                ? require("../../../../assets/images/superadmin/ordericon/skip the line.svg")
                                : ""
                            }
                            alt={
                              allLocationData &&
                              allLocationData.order_type === 0
                                ? "takeaway"
                                : allLocationData &&
                                  allLocationData.order_type === 1
                                ? "curb side"
                                : allLocationData &&
                                  allLocationData.order_type === 3
                                ? "dine in"
                                : ""
                            }
                            title={
                              allLocationData &&
                              allLocationData.order_type === 0
                                ? "takeaway"
                                : allLocationData &&
                                  allLocationData.order_type === 1
                                ? "curb side"
                                : allLocationData &&
                                  allLocationData.order_type === 3
                                ? "dine in"
                                : ""
                            }
                            width="35px"
                          />
                        </>
                      ) : (
                        <div className="f12-500 pb-2">
                          Name /{" "}
                          {allLocationData.type === "ordering"
                            ? "Order"
                            : "Request"}{" "}
                          Number
                        </div>
                      )}
                      {this.props.actionBy === "merchantOrder" ? (
                        ""
                      ) : (
                        <div className="d-flex">
                          {allLocationData.isWalkIn === true &&
                          allLocationData.service_type === "SEATING" ? (
                            <Image
                              src={require("../../../../assets/images/ActionImages/image/walkin.svg")}
                              alt="Order Type"
                              title="Order Type"
                              className="order-type-Image mr-3"
                            />
                          ) : null ||
                            (allLocationData.isWalkIn === false &&
                              allLocationData.service_type === "SEATING") ? (
                            <Image
                              src={require("../../../../assets/images/ActionImages/image/waitlist.svg")}
                              alt="Order Type"
                              title="Order Type"
                              className="order-type-Image mr-3"
                            />
                          ) : null ||
                            (allLocationData.isWalkIn === false &&
                              allLocationData.service_type ===
                                "RESERVATION") ? (
                            <Image
                              src={require("../../../../assets/images/ActionImages/image/reservation.svg")}
                              alt="Order Type"
                              title="Order Type"
                              className="order-type-Image mr-3"
                            />
                          ) : null}
                          <div>
                            <div className="f12-500">{this.state.name}</div>
                            <div className="f9-400">
                              #
                              {this.props?.type === "EVENT"
                                ? allLocationData.event_request_id
                                : allLocationData.diner_id}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    {allLocationData.type === "ordering" ? (
                      <> </>
                    ) : (
                      <div
                        className={
                          this.props.actionBy === "merchantOrder"
                            ? "col-9 col-md-7"
                            : "col-6 py-2 col-md-4 user-section"
                        }
                      >
                        <div
                          className={
                            this.props.actionBy === "merchantOrder"
                              ? "f12-500 pb-2 pt-2"
                              : "f12-500 pb-2"
                          }
                        >
                          {this.props.actionBy === "merchantOrder"
                            ? "Name Request No."
                            : "Total PAX"}
                        </div>
                        {this.props.actionBy === "merchantOrder" ? (
                          <div>
                            <div className="f12-500">
                              {allLocationData &&
                                allLocationData?.user_details?.first_name +
                                  " " +
                                  allLocationData?.user_details?.last_name}
                            </div>
                            <div className="f9-400">
                              #{allLocationData?.order_id}
                            </div>
                          </div>
                        ) : (
                          <div className="d-flex mt-0 request-accept-cancelled-center">
                            <div className="col-auto px-0">
                              <div className="f14-700 text-right">
                                {allLocationData.adult_count +
                                  allLocationData.kids_count}
                              </div>
                              <div className="f10-700">PAX</div>
                            </div>
                            <div className="col-auto px-2">
                              <div className="d-flex align-items-center mb-2 ">
                                <Image
                                  src={require("../../../../assets/images/ActionImages/employees.png")}
                                  fluid
                                  width="20px"
                                  alt="Adult"
                                  title="Adult"
                                  className="icon-image"
                                />
                                <span className="">
                                  {allLocationData.adult_count}
                                </span>
                              </div>
                              <div className="d-flex align-items-center ">
                                <Image
                                  src={require("../../../../assets/images/ActionImages/children.png")}
                                  fluid
                                  width="20px"
                                  alt="Children"
                                  title="Children"
                                  className="icon-image"
                                />
                                <span className="">
                                  {allLocationData.kids_count}
                                </span>
                              </div>
                            </div>
                            <div className="col-auto px-0">
                              {allLocationData.high_chair === 0 ? null : (
                                <div className="d-flex align-items-center mb-2">
                                  <Image
                                    src={require("../../../../assets/images/ActionImages/highchair.png")}
                                    fluid
                                    width="20px"
                                    alt="Highchair"
                                    title="Highchair"
                                    className="icon-image-small"
                                  />
                                  <span className="">
                                    {allLocationData.high_chair}
                                  </span>
                                </div>
                              )}
                              {allLocationData.handicap_chair === 0 ? null : (
                                <div className="d-flex align-items-center">
                                  <Image
                                    src={require("../../../../assets/images/ActionImages/wheelchair.png")}
                                    fluid
                                    width="20px"
                                    alt="Wheel Chair"
                                    title="Wheel Chair"
                                    className="icon-image-small"
                                  />
                                  <span className="">
                                    {allLocationData.handicap_chair}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                    <div className="col-6 col-md-3 py-2">
                      <div className="f12-500 pb-2">ETA</div>
                      <p className="f18-700 text-red">
                        {!isEmpty(this.state.distance)
                          ? `${moment()
                              .add(this.state.distance.eta, "s")
                              .format("MMM Do [at] LT")}`
                          : ``}
                      </p>
                    </div>
                  </Row>
                  <hr />
                  <div className="row px-3 justify-content-center mt-3 mb-4">
                    <div className="col-auto px-0">
                      {/* <CallingButtonPopup
                        displayButton={"OrderMain"}
                        buttonClass="bigButton"
                        sendData={allLocationData}
                      /> */}

                      <CallingIconButtonActionFile
                        orderDetails={allLocationData?.user_details}
                        actionType="orderFirstLastName"
                      />
                    </div>
                    <div className="col-auto px-0">
                      {this.props.actionBy === "merchantOrder" ? (
                        <SendSmsNew
                          mobile_number={
                            allLocationData &&
                            allLocationData.user_details &&
                            allLocationData.user_details.mobile_number
                          }
                          first_name={
                            allLocationData &&
                            allLocationData.user_details &&
                            allLocationData.user_details.first_name &&
                            allLocationData.user_details.last_name
                              ? allLocationData.user_details.first_name +
                                " " +
                                allLocationData.user_details.last_name
                              : ""
                          }
                          type="order"
                          order_id={allLocationData._id}
                        />
                      ) : (
                        <SendSmsButton buttonClass="bigButton" />
                      )}
                    </div>
                    <div className="col-auto px-0">
                      {this.props.actionBy === "merchantOrder" ? (
                        <NotificationsNew
                          order_id={allLocationData._id}
                          dataSend={allLocationData}
                        />
                      ) : (
                        <NotificationButton buttonClass="bigButton" />
                      )}
                    </div>
                    {/* <div className="col-auto px-0">
                      <ViewButtonPopup buttonClass="bigButton" />
                       <Button
                        variant="link"
                        className="enIconBtn"
                        onClick={this.handleShowMap}
                      >
                        <Image
                          src={require("../../../../assets/images/UserManagement/eye.svg")}
                          alt="View"
                          title="View"
                        />
                      </Button>
                    </div> */}
                  </div>
                </div>
                <div className="py-3">
                  <p className="f12-500">{`Updated Location : ${
                    this.state.distance.distance || 0
                  } KMS`}</p>
                </div>
                <hr className="mt-0" />
                {/* <MapReusable /> */}
                {allLocationData.track_location ? (
                  <TestMap
                    restaurantLocation={
                      this.props?.type === "EVENT"
                        ? this.props?.dataSend?.location
                        : this.props.onboarding
                    }
                    userLocation={
                      allLocationData && allLocationData.track_location
                    }
                    travelMode={allLocationData?.travelMode}
                    socket={this.props.socket}
                    orderType={allLocationData?.order_type}
                  />
                ) : (
                  <div> User Location Not Available </div>
                )}
                {/* {showMap ? (
                  <MapReusable />
                ) : (
                  <div className="enGrayBorderBox d-flex align-items-center justify-content-center h-168">
                    <span className="f12-500 text-red">Not Available</span>
                  </div>
                )} */}
              </div>
            </Media>
          </div>
        </Modal>
      </div>
    );
  }
}

LocationReusableScreen.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding:
    state.onboarding &&
    state.onboarding.restaurantDetails &&
    state.onboarding.restaurantDetails.location,
  distance: state.distance,
});

const LocationReusable = (props) => (
  <SocketContext.Consumer>
    {(socket) => <LocationReusableScreen {...props} socket={socket} />}
  </SocketContext.Consumer>
);

export default connect(mapStateToProps, {
  clear_all_errors,
})(withRouter(LocationReusable));
